import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import AddressList from "@/pages/address/List";

const AddressCreate = lazy(() => import("@/pages/address/Create"));

const addressRoutes: RouteObject[] = [
  {
    path: "/address/list",
    element: <AddressList />,
  },
  {
    path: "/address/create",
    element: <AddressCreate />,
  },
  {
    path: "/address/edit",
    element: <AddressCreate />,
  },
];

export default addressRoutes;
